import { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import { createUser } from "./../../REDUX/Models/users.Model";
import { addUser, signIn, setError } from "./../../REDUX/Slices/users.Slice";
import { useSelector, useDispatch } from "react-redux";
import register from "./../../assets/icons/register.svg";
import "./index.scss";

export default function Register() {
  const [user, setUser] = useState({
    user_name: "",
    first_name: "",
    last_name: "",
    email: "",
    confirm_email: "",
    password: "",
    confirm_password: "",
  });

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const err = useSelector((state) => state.error);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleChange = (e) => {
    setUser({ ...user, [e.target.name]: e.target.value });
    dispatch(setError(null));
  };

  const passwordRegex =
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d])[^\s]{8,}$/;

  const handleSubmit = async (e) => {
    e.preventDefault();
    dispatch(setError(null));

    try {
      const requiredFields = [
        "first_name",
        "last_name",
        "user_name",
        "email",
        "confirm_email",
        "password",
        "confirm_password",
      ];

      for (let field of requiredFields) {
        if (!user[field] || user[field].trim() === "") {
          dispatch(setError("يرجى ملء جميع الحقول المطلوبة"));
          return;
        }
      }

      if (user.email !== user.confirm_email) {
        dispatch(setError("البريد الإلكتروني غير متطابق"));
        return;
      }

      if (user.password !== user.confirm_password) {
        dispatch(setError("كلمة المرور غير متطابقة"));
        return;
      }

      if (!passwordRegex.test(user.password)) {
        dispatch(
          setError(
            "كلمة المرور يجب أن تحتوي على 8 أحرف على الأقل، حرف كبير، حرف صغير، رقم، ورمز خاص."
          )
        );
        return;
      }

      const payload = {
        user_name: user.user_name.trim(),
        first_name: user.first_name.trim(),
        last_name: user.last_name.trim(),
        email: user.email.trim(),
        password: user.password,
      };

      await createUser(payload).then((res) => {
        const { response, token } = res.data.user;
        dispatch(addUser({ response, token }));
        dispatch(signIn());
      });

      navigate("/loading", { replace: true });
    } catch (err) {
      let errorMsg = "حدث خطأ أثناء التسجيل. يرجى المحاولة لاحقًا.";
      const status = err?.response?.status;
      if (status === 400) {
        errorMsg = "البريد الإلكتروني مسجل مسبقًا.";
      } else if (status === 409) {
        errorMsg = "اسم المستخدم موجود بالفعل.";
      } else {
        errorMsg = "خطأ في الخادم. حاول مرة أخرى لاحقًا.";
      }

      dispatch(setError(errorMsg));
    }
  };

  useEffect(() => {
    document.title = `طورنى - تسجيل حساب جديد`;
    dispatch(setError(null));
  }, []);

  return (
    <div className="register">
      <div className="container">
        <div className="row">
          <div className="register-img">
            <img src={register} alt="Register" />
          </div>
          <div className="register-form">
            <h2>تسجيل حساب جديد</h2>
            <form onSubmit={handleSubmit}>
              <input
                type="text"
                name="first_name"
                placeholder="الاسم الأول"
                required
                onChange={handleChange}
              />
              <input
                type="text"
                name="last_name"
                placeholder="الاسم الأخير"
                required
                onChange={handleChange}
              />
              <input
                type="text"
                name="user_name"
                placeholder="اسم المستخدم"
                required
                onChange={handleChange}
              />
              <input
                type="email"
                name="email"
                placeholder="البريد الالكترونى"
                required
                onChange={handleChange}
              />
              <input
                type="email"
                name="confirm_email"
                placeholder="تأكيد البريد الالكترونى"
                required
                onChange={handleChange}
              />
              <div className="password-field">
                <input
                  type={showPassword ? "text" : "password"}
                  name="password"
                  placeholder="كلمة السر"
                  required
                  onChange={handleChange}
                />
                <span
                  className="toggle-password"
                  onClick={() => setShowPassword(!showPassword)}
                >
                  {showPassword ? (
                    <i className="fa-light fa-lock-open"></i>
                  ) : (
                    <i className="fa-light fa-lock"></i>
                  )}
                </span>
              </div>

              <div className="password-field">
                <input
                  type={showConfirmPassword ? "text" : "password"}
                  name="confirm_password"
                  placeholder="تأكيد كلمة السر"
                  required
                  onChange={handleChange}
                />
                <span
                  className="toggle-password"
                  onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                >
                  {showConfirmPassword ? (
                    <i className="fa-light fa-lock-open"></i>
                  ) : (
                    <i className="fa-light fa-lock"></i>
                  )}
                </span>
              </div>

              <button type="submit">تسجيل</button>
            </form>
            <div className="links">
              <Link to="/login">او يمكنك تسجيل الدخول</Link>
              {err && <span className="error">{err}</span>}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
